import { useIsClient } from '@as/cotopaxi';
import { createPortal } from 'react-dom';
export const NotificationMessage = ({ children }) => {
    const isClient = useIsClient();
    if (!isClient)
        return null;
    const messageContainer = document.getElementById('notification__container');
    return messageContainer ? createPortal(children, messageContainer) : null;
};
